import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOtherSubjectDetailAction} from '../action';

function* execute({payload: {userRoleId}}: GetManagementOtherSubjectDetailAction): SagaIterator {
    const response = yield* call(Api.getUserProfileOtherSubjectRoleBinding, {userRoleId});

    if (response.isSuccess) {
        const optData = opt(response.data);
        yield* put(adminAction.getManagementOtherSubjectDetailSuccess(optData));
        yield* put(adminAction.setManagementOtherSubjectsUsers(optData.prop('user').toArray()));
        yield* put(adminAction.setManagementOtherSubjectsRoles(optData.prop('role').toArray()));
    } else {
        yield putAll(showBeError(response, t('admin')('loadDetail')));
    }
}
/** Runs the admin saga that loads the selected other-subject management detail. */
export function* getManagementOtherSubjectDetailSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_OTHER_SUBJECT_DETAIL', execute);
}
